/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';
import { tokens } from '@companycam/slab-tokens';

const getButtonPadding = (size) => {
  switch (size) {
    case 'tiny':
      return '4px 8px';
    case 'small':
      return '12px 16px';
    default:
      return '12px 24px';
  }
};

const getButtonFontSize = (size) => {
  switch (size) {
    case 'tiny':
      return '12px';
    case 'small':
      return '14px';
    default:
      return '16px';
  }
};

const TextButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: white;
  text-decoration: none;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    Roboto, Helvetica Neue, Arial, sans-serif;
  font-weight: 700;
  margin: ${(props) => (props.addSpacing ? '4px' : null)};
  font-size: ${(props) => getButtonFontSize(props.fontSize)};
  padding: ${(props) => getButtonPadding(props.buttonPadding)};

  border: none;
  cursor: pointer;
`;

const TextButtonPrimary = styled(TextButton)`
  background-color: ${tokens.color_brand_primary};
  :hover {
    background-color: #0757b2;
    transition: 150ms ease-in-out;
  }
  :active {
    background-color: #2d7dd8;
  }
`;

const TextButtonDestroy = styled(TextButton)`
  background-color: ${tokens.color_utility_destroy_le};
  :hover {
    background-color: #cb4242;
    transition: 150ms ease-in-out;
  }
  :active {
    background-color: #cb4242;
  }
`;

const TextButtonCancel = styled(TextButton)`
  color: ${tokens.color_label_dark_gray};
  background-color: ${tokens.color_background_3_le};
  :hover {
    background-color: ${tokens.color_background_2_le};
    transition: 150ms ease-in-out;
  }
  :active {
    background-color: ${tokens.color_background_3_le};
  }
`;

const ButtonPrimary = (props) => (
  <TextButtonPrimary
    data-testid="editor-modal__button-primary"
    fontSize={props.size}
    buttonPadding={props.size}
    {...props}
  />
);

const ButtonDestroy = (props) => (
  <TextButtonDestroy
    data-testid="editor-modal__button-destroy"
    fontSize={props.size}
    buttonPadding={props.size}
    {...props}
  />
);

const ButtonCancel = (props) => (
  <TextButtonCancel
    data-testid="editor-modal__button-cancel"
    fontSize={props.size}
    buttonPadding={props.size}
    {...props}
  />
);

export { ButtonCancel, ButtonDestroy, ButtonPrimary };
